module.exports = __webpack_public_path__ + "static/media/young_ivan_soccer.214dd40c.jpg";